import { Component, Input } from '@angular/core';

@Component({
	// eslint-disable-next-line @angular-eslint/component-selector
	selector: 'ac-error-with-exclamation',
	templateUrl: './error-with-exclamation.component.html',
	styleUrls: ['./error-with-exclamation.component.scss']
})
export class ErrorWithExclamationComponent {
	@Input() public errorDcrKey: string = '';
}
